// extracted by mini-css-extract-plugin
export default {"platformsGrid":"dtWqg3aC82RQ9KYC5Xms","mobileGridSpacer":"cPEE8zTgaA8Chv6ZI5gG"};